import React, { Component } from 'react';
import PropTypes from "prop-types";

class Badge extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        const {
            className, text
        } = this.props;

        const finalClassName = `tw-text-white tw-text-sm tw-py-3 tw-px-4 ${className}`;

        return (
            <div className={finalClassName} role="alert">
                <p>{text}</p>
            </div>
        );
    }
}

Badge.defaultProps = {
    className: '',
};

Badge.propTypes = {
    className: PropTypes.string,
    text: PropTypes.node.isRequired,
};

export default Badge;
